export default {
  /*
   * get() obtiene la posición más cercana a la ruta por la que van a pasar buses
   */
  get(params) {
    return Vue.http.get('api_positions/next_buses', params).then(response => response)
  }
}
